"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = watchUserLogin;

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _humps = require("humps");

var _effects = require("redux-saga/effects");

var _utils = require("@dom/utils");

var _types = require("../actions/types");

var _user = require("../actions/user");

var _marked =
/*#__PURE__*/
_regenerator["default"].mark(watchUserLogin),
    _marked2 =
/*#__PURE__*/
_regenerator["default"].mark(saveUserInformation);

function watchUserLogin() {
  return _regenerator["default"].wrap(function watchUserLogin$(_context) {
    while (1) {
      switch (_context.prev = _context.next) {
        case 0:
          _context.next = 2;
          return (0, _effects.all)([(0, _effects.takeLatest)(_types.INIT_USER_INFO, saveUserInformation)]);

        case 2:
        case "end":
          return _context.stop();
      }
    }
  }, _marked);
}

function saveUserInformation(_ref) {
  var token, _ref2, data;

  return _regenerator["default"].wrap(function saveUserInformation$(_context2) {
    while (1) {
      switch (_context2.prev = _context2.next) {
        case 0:
          token = _ref.token;
          _context2.prev = 1;
          _context2.next = 4;
          return (0, _effects.call)(_utils.api.getWithToken, _utils.endpoints.profile.getMyData);

        case 4:
          _ref2 = _context2.sent;
          data = _ref2.data; // eslint-disable-line

          localStorage.setItem('userId', data.id);
          _context2.next = 9;
          return (0, _effects.put)((0, _user.storeUserInfo)((0, _humps.camelizeKeys)(data), token));

        case 9:
          _context2.next = 14;
          break;

        case 11:
          _context2.prev = 11;
          _context2.t0 = _context2["catch"](1);
          console.log('cant save your information. damn!', _context2.t0.response);

        case 14:
        case "end":
          return _context2.stop();
      }
    }
  }, _marked2, null, [[1, 11]]);
}